import { render } from "./Ident.vue?vue&type=template&id=77d30b98"
import script from "./Ident.vue?vue&type=script&lang=js"
export * from "./Ident.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__